export default "__VITE_ASSET__CGYwl88l__"